<template>
  <div class="exchange-modal" v-if="isVisible">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="exchange-modal" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">
      <!-- 弹窗头部 -->
      <div class="popup-header" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">奖品兑换</div>
      
      <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="close-btn"  @click="handleClosePopup" alt="">

      <!-- 提示文本 -->
      <p class="prompt-text">请输入11位手机号，兑换券包至您的账户</p>

      <!-- 手机号输入框 -->
      <input 
        type="tel" 
        class="phone-input" 
        placeholder="请输入手机号" 
        v-model="phoneNumber"
        maxlength="11"
        :style="{
          'background': h5ConfigDetails[0]['fontColor']['inputBg'][0],
          'color': h5ConfigDetails[0]['fontColor']['prizeNameOrInputFontColor'][0],
          '--placeholder-color': h5ConfigDetails[0]['fontColor']['notInputFontColor'][0]
        }"
      >

      <!-- 注意事项 -->
      <p class="notice-text">注意：手机号一旦提交,无法修改。请务必确认手机号填写正确。</p>

      <p class="error-text" :style="`color: ${h5ConfigDetails[0]['fontColor']['noticeTxtColor'][0]};`">{{phoneNumberErrorText}}</p>

      <!-- 兑换按钮 -->
      <div class="exchange-btn" @click="handleExchange" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`">立即兑换</div>
    </div>
  </div>
</template>

<script>
import { postCouponByCouponId, getCouponsByUserId } from '@/service/apis'
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'PrizeExchangePopup',
  components: { ModalMask },
  data() {
    return {
      baseUrl,
      isVisible: false,
      coupon: null,
      phoneNumber: '',
      phoneNumberErrorText: '',
      pollTimer: null,
      pollCount: 0
    };
  },
  methods: {
    show (couponHis) {
      this.isVisible = true
      this.coupon = couponHis
    },
    // 关闭弹窗
    handleClosePopup() {
      this.isVisible = false
      // this.$emit('update:isVisible', false);
    },
    // 处理兑换逻辑
    async handleExchange() {
      if (this._validate_phone()) {
        // 这里可以添加调用兑换接口的逻辑
        console.log(`兑换请求：手机号=${this.phoneNumber}`);
        try {
          await postCouponByCouponId(this.userInfo.userId, this.coupon.couponId, {
            voucherPhone: this.phoneNumber
          })
  
          this.handleClosePopup()
          this.$emit('show-loading', true)
          this._check_exchange_result()
        } catch (error) {
          this.$emit('exchange-result', false)
        }
      }
    },
    async _check_exchange_result () {
      try {
        if (this.pollCount >= 5) {
          this._stop_polling()
          this.$toast('查询超时，请稍后重试')
          return
        }
  
        const res = await getCouponsByUserId(this.userInfo.userId)
        this.pollCount++
  
        if (res && res.exchangeHistoryList) {
          const couponResult = res.exchangeHistoryList.find(cur => {
            return cur.couponId === this.coupon.couponId && cur.couponType === 12
          })
  
          if (couponResult.couponStatus === 2) {
            this.$emit('exchange-result', true, couponResult)
            this._stop_polling()
            return
          }
  
          if (couponResult.couponStatus === 3) {
            this.$emit('exchange-result', false, couponResult)
            this._stop_polling()
            return
          }
        }
  
        this.pollTimer = setTimeout(() => {
          this._check_exchange_result()
        }, 3000)
      } catch (error) {
        this.$emit('exchange-result', false)
        this._stop_polling()
      }
    },
    _stop_polling () {
      this.pollCount = 0
      this.$emit('show-loading', false)
      clearTimeout(this.pollTimer)
    },
    // 手机号验证
    _validate_phone() {
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(this.phoneNumber)) {
        this.phoneNumberErrorText = '手机号格式输入错误'
        return false;
      }
      return true;
    }
  },
  computed: {
    ...mapState(['userInfo', 'h5ConfigDetails', 'h5ConfigImgPath']),
  },
};
</script>

<style scoped lang="less">
@import '../../style/mixin';

.exchange-modal {
  .modal-common;
  width: 30rem;
  height: 25.3rem;
  background: #FFF7EE;
  border-radius: .9rem;
  padding: 1.7rem 2.1rem 1.4rem;
}

.popup-header {
  font-weight: 500;
  font-size: 1.8rem;
  color: #7E3E1B;
  text-align: center;
  margin-bottom: 1.8rem;
}

.close-btn {
  position: absolute;
  top: .8rem;
  right: 1.1rem;
  width: 1.9rem;
  height: 1.9rem;
}

.prompt-text {
  font-size: 14px;
  margin-bottom: .8rem;
  text-align: center;
}

.phone-input {
  width: 25.5rem;
  height: 4.4rem;
  color: var(--placeholder-color);
  background: #FFF;
  border-radius: .7rem;
  text-align: center;
  margin-bottom: .8rem;
}

.phone-input::placeholder {
  color: var(--placeholder-color) !important;
  opacity: 1; /* 确保颜色生效 */
}

/* 浏览器兼容性处理 */
.phone-input::-webkit-input-placeholder {
  color: var(--placeholder-color) !important;
}
.phone-input::-moz-placeholder {
  color: var(--placeholder-color) !important;
}
.phone-input:-ms-input-placeholder {
  color: var(--placeholder-color) !important;
}

.notice-text {
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.error-text {
  font-size: 1.1rem;
  color: #e71919;
  text-align: center;
  height: 2rem;
  // margin-bottom: 1.8rem;
}

.exchange-btn {
  width: 25.5rem;
  height: 4rem;
  line-height: 4rem;
  background: #FA733C;
  border-radius: 2rem;
  font-weight: 600;
  font-size: 1.6rem;
  color: #FFF;
  text-align: center;
}

</style>